import { useState } from 'react';
import { Send } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const INITIAL_FORM = {
  nombre: '',
  email: '',
  telefono: '',
  asunto: '',
  mensaje: ''
};

const inputClass =
  'w-full px-4 py-3 bg-stone-50/50 border border-stone-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#43b6b8]/20 focus:border-[#43b6b8]';

export const ContactForm = () => {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await axios.post(`${API}/contact`, formData);
      setSubmitStatus('success');
      setFormData(INITIAL_FORM);
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <h2 className="text-3xl font-semibold text-stone-900 mb-6">
        Envíanos un mensaje
      </h2>
      <div className="bg-white p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
        <form onSubmit={handleSubmit} data-testid="contact-form">
          <div className="space-y-6">
            <div>
              <label htmlFor="nombre" className="block text-sm font-medium text-stone-900 mb-2">
                Nombre completo *
              </label>
              <input
                type="text" id="nombre" name="nombre"
                value={formData.nombre} onChange={handleChange} required
                data-testid="contact-input-nombre" className={inputClass}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-stone-900 mb-2">
                  Email *
                </label>
                <input
                  type="email" id="email" name="email"
                  value={formData.email} onChange={handleChange} required
                  data-testid="contact-input-email" className={inputClass}
                />
              </div>
              <div>
                <label htmlFor="telefono" className="block text-sm font-medium text-stone-900 mb-2">
                  Teléfono *
                </label>
                <input
                  type="tel" id="telefono" name="telefono"
                  value={formData.telefono} onChange={handleChange} required
                  data-testid="contact-input-telefono" className={inputClass}
                />
              </div>
            </div>

            <div>
              <label htmlFor="asunto" className="block text-sm font-medium text-stone-900 mb-2">
                Asunto *
              </label>
              <input
                type="text" id="asunto" name="asunto"
                value={formData.asunto} onChange={handleChange} required
                data-testid="contact-input-asunto" className={inputClass}
              />
            </div>

            <div>
              <label htmlFor="mensaje" className="block text-sm font-medium text-stone-900 mb-2">
                Mensaje *
              </label>
              <textarea
                id="mensaje" name="mensaje"
                value={formData.mensaje} onChange={handleChange} required rows="5"
                data-testid="contact-textarea-mensaje" className={inputClass}
              ></textarea>
            </div>

            {submitStatus === 'success' && (
              <div className="p-4 bg-green-50 border border-green-200 rounded-xl" data-testid="contact-success-message">
                <p className="text-green-800 text-sm">
                  ¡Gracias por contactarnos! Responderemos tu mensaje pronto.
                </p>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="p-4 bg-red-50 border border-red-200 rounded-xl" data-testid="contact-error-message">
                <p className="text-red-800 text-sm">
                  Hubo un error al enviar tu mensaje. Por favor, intenta nuevamente o llámanos directamente.
                </p>
              </div>
            )}

            <button
              type="submit" disabled={isSubmitting}
              data-testid="submit-contact-form"
              className="w-full bg-[#d3b163] hover:bg-[#b89548] text-white px-8 py-4 rounded-full font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed active:scale-95 flex items-center justify-center gap-2 shadow-md"
            >
              {isSubmitting ? 'Enviando...' : (
                <>
                  <Send className="w-5 h-5" />
                  Enviar Mensaje
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
